import {
	FETCH_ACCESS_BEGIN,
	FETCH_ACCESS_SUCCESS,
	FETCH_ACCESS_ERROR,
} from "../actions/accessActions"

// `loaded` est le champ CRITIQUE : les gardes de route s'évaluent au tout
// premier render, avant la réponse d'api/access. Tant que `loaded` est faux,
// ProtectedRoute doit attendre au lieu de rediriger — sinon chaque F5 éjecte
// l'utilisateur vers /home.
const initialState = {
	modules: [],
	// Catégories de notifications du user, résolues serveur = celles qu'il reçoit
	// ET peut consulter (depuis le 30.07.2026 c'est la même chose : la « lecture
	// ouverte » a été retirée, seules les cases cochées comptent).
	notifCategories: [],
	loaded: false,
	fetchAccess: {
		loading: false,
		error: false,
	},
}

export default function accessReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_ACCESS_BEGIN:
			return {
				...state,
				fetchAccess: { loading: true, error: false },
			}
		case FETCH_ACCESS_SUCCESS:
			return {
				...state,
				modules: action.payload.modules,
				notifCategories: action.payload.notifCategories,
				loaded: true,
				fetchAccess: { loading: false, error: false },
			}
		case FETCH_ACCESS_ERROR:
			// Échec du chargement : on marque quand même `loaded` pour ne pas
			// bloquer l'app sur un loader éternel. La map reste vide → les
			// routes gatées redirigent, mais le backend est de toute façon la
			// vraie barrière (le front n'est que cosmétique).
			return {
				...state,
				loaded: true,
				fetchAccess: { loading: false, error: action.payload },
			}
		default:
			return state
	}
}
